"use client";

import { Provider } from "jotai";
export function ThemeProvider({ children }: React.PropsWithChildren<{}>) {
  return <>{children}</>;
}

export function JotaiProvider({ children }: React.PropsWithChildren<{}>) {
  return <Provider>{children}</Provider>;
}
